module.exports = __webpack_public_path__ + "static/media/zoom-in.f37f83e5.svg";